export default (url) =>()=>import(`@/views/${url}.vue`)

